module.exports = __webpack_public_path__ + "static/media/DSC01470.2cdcaa69.jpg";